import jwtDecode from 'jwt-decode';

import type { TokenDto } from '../interfaces/token-dto';

export function decodeAuthToken(token?: string | null): TokenDto | null {
  if (!token) {
    return null;
  }

  let decodedToken: TokenDto | null = null;

  try {
    decodedToken = jwtDecode<TokenDto>(token);
  } catch (e) {
    console.error(e);
  }

  return decodedToken;
}

export function getPersonIdFromToken(accessToken: string) {
  const decodedToken = decodeAuthToken(accessToken);
  return decodedToken && decodedToken.PERSON_ID;
}
